import cx from 'classnames'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'
import { Themes } from '@commutifi-fe/ui/components/theme/constants'
import { Flex, Layout, Switch } from '@commutifi-fe/ui'
import styles from './styles.module.scss'
import { useConfig } from 'shared/providers'

interface SurveyLayoutProps {
  className?: string
  children: React.ReactNode
}

function SurveyLayout({ children, className }: SurveyLayoutProps) {
  const {
    locale,
    changeLocale,
    theme: { currentTheme },
    changeTheme
  } = useConfig()
  const handleToggleTheme = () => changeTheme(currentTheme === Themes.DARK ? Themes.LIGHT : Themes.DARK)

  return (
    <Layout className={cx('u-bg-color--layout', styles['survey-container'], className)} data-testid="survey-layout">
      {/* On small screen the Steps component button is fixed to the bottom of the screen so we need to make sure the content is not hidden */}
      <Layout.Content id="main-content" style={{ display: 'flex' }}>
        {children}
      </Layout.Content>
      <Layout.CommutifiFooter
        languageSwitcher={<Layout.CommutifiFooter.OfflineLocaleSelector locale={locale} onChange={changeLocale} />}
      >
        <Flex align="center">
          <Switch
            checked={currentTheme === Themes.DARK}
            checkedChildren={<FontAwesomeIcon icon={faSun} />}
            onClick={handleToggleTheme}
            unCheckedChildren={<FontAwesomeIcon icon={faMoon} />}
          />
        </Flex>
      </Layout.CommutifiFooter>
    </Layout>
  )
}

export default SurveyLayout
